import { render, staticRenderFns } from "./MasterTopBar.vue?vue&type=template&id=07f633d9&scoped=true"
import script from "./MasterTopBar.vue?vue&type=script&lang=js"
export * from "./MasterTopBar.vue?vue&type=script&lang=js"
import style0 from "./MasterTopBar.vue?vue&type=style&index=0&id=07f633d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f633d9",
  null
  
)

export default component.exports